module.exports = "<div class=\"ui-select-no-choice selectize-dropdown\" ng-show=\"$select.open && $select.items.length == 0\"><div class=selectize-dropdown-content><div data-selectable ng-transclude></div></div></div>"


//////////////////
// WEBPACK FOOTER
// ./src/ui/core/common/components/filtered-select/no-choice.tpl.html
// module id = 107
// module chunks = 1